import React, { useState ,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import './log_in.css';
import LogInMobile from './log_in_mobile.js';
import { API_BASE_URL } from '../config.js';
export default function LogIn() {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
 const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      // 1. طلب تسجيل الدخول الأساسي للحصول على التوكن
      const response = await fetch(`${ API_BASE_URL }/token/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: phone, 
          password: password,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        // حفظ التوكنات مبدئياً لنتمكن من استخدامها في الطلبات التالية
        localStorage.setItem('access_token', data.access);
        localStorage.setItem('refresh_token', data.refresh);

        // 2. التحقق مما إذا كان المستخدم طبيباً عبر جلب بياناته الشخصية
        const doctorResponse = await fetch(`${API_BASE_URL}/doctors/me/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${data.access}`
            }
        });

        if (doctorResponse.ok) {
            const doctorData = await doctorResponse.json();
            
            // حفظ بيانات الطبيب في التخزين المحلي
            localStorage.setItem('user_role', 'doctor');
            localStorage.setItem('username', doctorData.username || phone);
            localStorage.setItem('user_id', doctorData.user_id || '');
            localStorage.setItem('doctor_id', doctorData.id);
            localStorage.setItem('real_name', doctorData.real_name || '');
            localStorage.setItem('phon_number', doctorData.phon_number || '');
            localStorage.setItem('email', doctorData.email || '');
            localStorage.setItem('specialty', doctorData.specialization || '');
            localStorage.setItem('hospital', doctorData.hospital_name || '');
            localStorage.setItem('city', doctorData.city || '');
            localStorage.setItem('hospital_address', doctorData.hospital_address || '');
            
            // التوجيه لواجهة الطبيب
            navigate('/Main');
            
        } else {
            // 3. إذا لم يكن طبيباً، نتحقق مما إذا كان مديراً عبر طلب مسار خاص بالأدمن فقط
            const adminResponse = await fetch(`${API_BASE_URL}/users/?limit=1`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${data.access}`
                }
            });

            if (adminResponse.ok) {
                // حفظ بيانات الأدمن
                localStorage.setItem('user_role', 'admin');
                localStorage.setItem('username', phone); 
                
                // التوجيه لواجهة الأدمن
                navigate('/Admin_Main');
                
            } else {
                // الحساب غير معروف الصلاحيات (أو غير مفعل)
                setError('تعذر تحديد صلاحيات الحساب أو أن الحساب غير مفعل.');
                localStorage.clear();
            }
        }
      } else {
        // عرض رسالة الخطأ القادمة من الخادم
        setError(data.detail || 'فشل تسجيل الدخول. يرجى التحقق من البيانات.');
      }
    } catch (err) {
      setError('حدث خطأ في الاتصال بالخادم.');
    } finally {
      setLoading(false);
    }
  };
  if (isMobile) {
    return (
      <LogInMobile 
        phone={phone}
        setPhone={setPhone}
        password={password}
        setPassword={setPassword}
        error={error}
        loading={loading}
        onLogin={handleLogin} 
        onNavigate={(page) => {
          if (page === 'register_step1') navigate('/');
          if (page === 'support') navigate('/support');
          if (page === 'login-support') navigate('/login-support');
        }} 
      />
    );
  }
  return (
    <div className="login-container" dir="ltr">
      <div className="login-left">
        <img className='syria-logo-login-logo' src="/images/Emblem_of_Syria_(2025–present).svg.png" alt="My Image" />
        <h1 className="login-title">الجمهورية العربية السورية</h1>
        <h4 className="login-sub">وزارة الصحة - منصة التنبؤ بالأوبئة</h4>
        
        <form className="login-form" onSubmit={handleLogin}>
          <h2 className="login-sub">تسجيل الدخول</h2>
          
          {error && <div style={{ color: 'red', marginBottom: '15px', textAlign: 'right', direction: 'rtl', fontSize: '14px', fontWeight: 'bold' }}>{error}</div>}

          <div className="input-row">
            <input
              placeholder="رقم الهاتف أو اسم المستخدم"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              type="text"
              required
            />
            <div className="icon" aria-hidden>
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#2f4f7a" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </div>
          </div>

          <div className="pass-row">
            <input
              placeholder="كلمة المرور" 
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type={show ? 'text' : 'password'}
              required
            />
            <div className="icon lock" aria-hidden onClick={() => setShow(!show)} style={{ cursor: 'pointer' }}>
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#9aa7b5" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            </div>
          </div>

          <button className="primary" type="submit" disabled={loading}>
            {loading ? 'جاري تسجيل الدخول...' : 'تسجيل الدخول'}
          </button>

          <div className="login-links">
           <p> لا تملك حساباً؟
           <span className="login-link" onClick={() => navigate("/")}>سجل الآن</span>
           </p>

           <p>
           <span className="login-link" onClick={() => navigate("/login-support")}> تواجه مشكلة في تسجيل الدخول؟</span>
           </p>
          </div>
        </form>
      </div>

      <div className="login-right">
        
      </div>
    </div>
  );
}